import { useState } from "react";
import { useShopShow } from "queries/shops";
import { useParams, useSearchParams } from "react-router-dom";
import { Api } from "queries/types";
import Stepper from "./Stepper";
import GeneralInformationStep from "./GeneralInformationStep";
import FurnitureConfigurationStep from "./FurnitureConfigurationStep";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface FunnelProps {
  shop: Api.Shop;
  step: number;
}

const Funnel = ({ shop: savedShop, step }: FunnelProps) => {
  const [, setSearchParams] = useSearchParams();
  const [shop, setShop] = useState(savedShop);

  return (
    <>
      {step === 1 && (
        <GeneralInformationStep shop={shop} setShop={setShop} onSubmitted={() => setSearchParams({ step: "2" })} />
      )}
      {/* {step === x && <MarketingConfigurationStep onSubmitted={() => setSearchParams({ step: "3" })} />} */}
      {step === 2 && <FurnitureConfigurationStep shop={shop} />}
    </>
  );
};

const ShopEditPage = () => {
  const { t } = useTranslation();
  const { erpId } = useParams<{ erpId: string }>();
  const [searchParams] = useSearchParams();
  const { data: shop, isFetching } = useShopShow(erpId!);
  const step = Number.parseInt(searchParams.get("step") || "1");

  return (
    <>
      <Typography component="h1" variant="h6" sx={{ mb: 1 }}>
        {t("shop.index.edit")}
      </Typography>
      <Stepper step={step} />
      {!isFetching && <Funnel shop={shop!} step={step} />}
    </>
  );
};

export default ShopEditPage;
